import ReactDiffViewer from "react-diff-viewer-continued";
import { Typography } from "@mui/material";
import styled from "styled-components";
import { UILayer } from "../../BuildlingBlocks/UILayer";

import { StyledLink } from "../../BuildlingBlocks/StyledLink";
import { StyledButton } from "../../BuildlingBlocks/StyledButton";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

interface CompareChangesLayerProps {
    oldValue: string;
    newValue: string;
    onApply: () => void;
    onCancel: () => void;
    title: string;
}

export const CompareChangesLayer = ({ oldValue, newValue, onApply, onCancel, title }: CompareChangesLayerProps) => {
    return (
        <UILayer
            open={true}
            fullWidth
            renderUI={() => {
                return (
                    <DiffLayerView>
                        <Typography variant="h5">{title}</Typography>
                        <DiffView>
                            <ReactDiffViewer
                                oldValue={oldValue}
                                newValue={newValue}
                                splitView
                                showDiffOnly={false}
                            />
                        </DiffView>
                        <GroupButtons>
                            <StyledLink onClick={onCancel}>Cancel</StyledLink>
                            <StyledButton
                                sx={{ background: UIStyleConstants.BLUE_COLOR }}
                                variant="contained"
                                onClick={onApply}
                            >
                                Apply
                            </StyledButton>
                        </GroupButtons>
                    </DiffLayerView>
                );
            }}
        />
    );
};

const DiffLayerView = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .MuiTypography-root.MuiTypography-h5 {
        padding: 6px;

        font-size: 20px;
        font-style: normal;
        font-weight: 600;
    }
`;

const DiffView = styled.div`
    overflow: auto;
    flex: 1;
`;

const GroupButtons = styled.div`
    display: flex;
    align-items: center;
    padding: 10px;
    justify-content: flex-end;

    > *:first-child {
        margin-right: 10px;
    }
`;
